import React from "react";

const LoadingScreen = () => {
  return <div className="loading-wrapper"></div>;
};

export default LoadingScreen;
